// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const purchaseOrderKeys = {
  all: ['purchase-order'] as const,
  purchaseOrderAddress: (purchaseOrderId: number) =>
    [...purchaseOrderKeys.all, purchaseOrderId, 'address'] as const,
};

export default purchaseOrderKeys;
